import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const ElectricityReplenishResponseSchema = z
  .object({
    data: z.object({
      purchase_id: z.number().nullable(),
      name: z.string(),
      created_at: z.string(),
      price_usd: z.number(),
      price_btc: z.number(),
      price_ltc: z.number(),
      price_ust: z.number(),
      price_eth: z.number(),
      units: z.number(),
      discount: z.number(),
      tax: z.number(),
      fee: z.number(),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TElectricityReplenishResponse = z.infer<typeof ElectricityReplenishResponseSchema>;
export type TElectricityReplenishData = TElectricityReplenishResponse['data'];
